/*
  Alpha Zen redesign: the mobile nav drawer.

  Per the mockup CSS, below 640px everything except the first menu item and the
  cart collapses behind the hamburger, which opens a drawer holding the full
  menu.
*/
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-az-burger]').forEach(function (burger) {
      if (burger.dataset.azReady === 'true') return;
      burger.dataset.azReady = 'true';

      const nav = burger.closest('.nav');
      const drawer = nav && nav.querySelector('.drawer');
      if (!drawer) return;

      burger.addEventListener('click', function () {
        const open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', open ? 'false' : 'true');
        drawer.classList.toggle('open', !open);
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
